import { z } from 'zod';

// Storefront visibility of a content page; DRAFT is the merchant-only state.
export const PageStatusEnum = z.enum(['PUBLISHED', 'DRAFT']);

// Role a page plays in the storefront; STANDARD is the plain content page this CRUD authors.
export const PageTypeEnum = z.enum(['STANDARD', 'LANDING_PAGE', 'HOME', 'PRODUCT', 'COLLECTION']);

// Search-engine listing overrides stored in the page's seoMetadata column.
export const PageSeoSchema = z.object({
  title: z.string().trim().max(255).nullable().optional(),
  description: z.string().trim().max(1000).nullable().optional()
});

// Handles are lowercase alphanumeric words joined by single dashes, the same shape slugify emits.
const SLUG_RE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export const CreatePageDtoSchema = z.object({
  title: z.string().trim().min(1, 'Page title is required').max(255),
  slug: z.string().trim().min(1).max(255).regex(SLUG_RE, 'slug must be lowercase words separated by dashes').optional(),
  bodyHtml: z.string().max(500_000, 'Page content exceeds the 500KB limit').default(''),
  status: PageStatusEnum.default('DRAFT'),
  pageType: PageTypeEnum.default('STANDARD'),
  seo: PageSeoSchema.default({})
});

export const UpdatePageDtoSchema = CreatePageDtoSchema.partial().refine(
  (v) => Object.values(v).some((field) => field !== undefined),
  { message: 'Nothing to update' }
);

export const PageQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(20),
  cursor: z.string().optional(),
  status: PageStatusEnum.optional(),
  pageType: PageTypeEnum.optional(),
  search: z.string().trim().min(1).max(255).optional()
});

export type PageSeo = z.infer<typeof PageSeoSchema>;
export type CreatePageDto = z.infer<typeof CreatePageDtoSchema>;
export type UpdatePageDto = z.infer<typeof UpdatePageDtoSchema>;
export type PageQuery = z.infer<typeof PageQuerySchema>;
